var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"hover",on:{"click":_vm.clickColumn}},[_vm._t("default"),_c('span',{staticClass:"ms-1"},[(_vm.sortDir=='asc')?_c('i',{staticClass:"bi bi-caret-up-fill font-11"}):(_vm.sortDir=='desc')?_c('i',{staticClass:"bi bi-caret-down-fill font-11"}):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }